export default [["en-us", {
  "app_name": "Ember Messaging Client",
  "empty_list_header": "Welcome to Secure Messaging",
  "empty_list_text": "You don't have any conversations yet"
}]];